export default __webpack_public_path__ + "static/media/About2.e37344fd.jpeg";